import { gql } from '@apollo/client';
import { templateItemBase, templateItemExtended } from './fragments';

export const TEMPLATE_QUERY = gql`
  query template($documentTemplateId: Int!) {
    template(documentTemplateId: $documentTemplateId) {
      ...templateItemBase
      ...templateItemExtended
    }
  }
  ${templateItemBase}
  ${templateItemExtended}
`;

export const OUTPUT_TYPES_QUERY = gql`
  query outputTypes {
    outputTypes {
      id
      name
    }
  }
`;

export const CONTENT_TYPES_QUERY = gql`
  query contentTypes {
    contentTypes {
      code
      name
    }
  }
`;

export const TARGET_AREAS_QUERY = gql`
  query targetAreas {
    targetAreas {
      id
      name
    }
  }
`;

export const SIGNATURE_ACTORS = gql`
  query signatureActors {
    signatureActors {
      actorId
      actorName
    }
  }
`;

export const OPTION_SOURCES = gql`
  query optionSources {
    optionSources {
      id
      code
      name
    }
  }
`;

export const ACTIVE_DOCUMENTS_QUERY = gql`
  query activeDocumentTypes {
    activeDocumentTypes {
      id
      code
      name
    }
  }
`;

export const SIGNATURE_TYPES_QUERY = gql`
  query signatureTypes {
    signatureTypes {
      id
      code
      name
    }
  }
`;

export const REQUIRED_DOC_TYPES_QUERY = gql`
  query requiredDocTypes {
    requiredDocTypes {
      id
      name
    }
  }
`;
